import { call, put, select } from 'redux-saga/effects';
import api from '../../../../services/api';
import * as Actions from './actions';

export function* getView() {
  try {
    const params = yield select((state) => state.visualizarProtocolo.id);
    const client = yield call(api, 'protocolo');

    const dados = yield call(client.post, 'consultasql/exec/visualizarheader', {
      filter: { idProtocolo: params.id },
    });
    yield put(Actions.viewSuccess(dados.data[0] ? dados.data[0] : {}));
  } catch (error) {}
}
